import type {
  MediaFile,
  MediaKind,
} from "@/components/common/media-preview/types";
import {
  formatFileSize,
  getFileExtension,
  inferMediaKind,
} from "@/lib/utils/mediaFile";

export const CARD_INTERACTIVE_CLASS =
  "cursor-pointer rounded-md border bg-gray-50 p-3 transition-colors hover:bg-gray-100";

export { formatFileSize, getFileExtension };

export type TileLayoutMode = "fill-column" | "fixed-width" | "fit-content";
export const TILE_GRID_GAP_CLASS = "gap-2 md:gap-3";
export const TILE_FIXED_WIDTH_CLASS =
  "w-[calc((100%-0.5rem)/2)] md:w-[calc((100%-0.75rem)/2)]";

export const getMediaKind = (file: MediaFile): MediaKind => {
  const kind = inferMediaKind({
    fileName: file.file_name,
    mimeType: file.mime_type,
  });
  return kind === "spreadsheet" ? "file" : kind;
};
